import { createSelector } from 'reselect';

const getList = state => {
    if (state.reports.get('savingPotentials')) {
        return state.reports.getIn(['savingPotentials', 'data']);
    }
    return [];
};

const savingPotentialsIsLoading = state => state.reports.getIn(['savingPotentials', 'isLoading']);

/* ====================== SELECTORS ======================== */
export const getSavingPotentialsList = createSelector([getList], list => list && list.toJS ? list.toJS() : list);

export const getSavingPotentialsIsLoading = createSelector(
    [savingPotentialsIsLoading],
    isLoading => isLoading
);
